module.exports = __webpack_public_path__ + "static/img/MC.5a3ef216.svg";